import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import RevealOnScroll from '../WrapComponents/RevealOnScroll.jsx';
import PageTransition from '../WrapComponents/PageTransition.jsx';
import axiosInstance from '../Axiosintances/Axiosinstance.jsx';

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axiosInstance.get('/service/api/v1/public_services');
        setServices(response.data);
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <PageTransition>
      <div className="bg-gray-50/50 dark:bg-gray-950 min-h-screen transition-colors duration-300 overflow-x-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-20">

          <RevealOnScroll className="text-center mb-10 md:mb-24">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight text-gray-900 dark:text-white">
              Our Services
            </h1>
            <p className="text-gray-500 dark:text-gray-400 max-w-2xl mx-auto text-lg leading-relaxed">
              Comprehensive solutions tailored to your construction and security needs.
            </p>
          </RevealOnScroll>

          <div className="space-y-32">
            {loading ? (
              <div className="text-center py-20">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black dark:border-white mx-auto mb-4"></div>
                <p className="text-gray-500 dark:text-gray-400">Loading services...</p>
              </div>
            ) : services.length > 0 ? (
              services.map((service, index) => (
                <div
                  key={service.id || index}
                  className={`grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-24 items-center ${index % 2 === 1 ? "lg:grid-flow-dense" : ""
                    }`}
                >

                  {/* Image Section */}
                  <RevealOnScroll
                    className={`relative rounded-2xl overflow-hidden h-[400px] lg:h-[500px] shadow-2xl group ${index % 2 === 1 ? "lg:col-start-2" : ""
                      }`}
                    direction={index % 2 === 0 ? "left" : "right"}
                    delay={100}
                  >
                    <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
                    <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
                      <img
                        src={service.image}
                        alt={service.name}
                        className="w-full h-auto object-contain"
                      />
                    </div>
                  </RevealOnScroll>

                  {/* Content Section */}
                  {/* Content Section */}
                  <RevealOnScroll
                    className="flex flex-col justify-center space-y-6"
                    direction={index % 2 === 0 ? "right" : "left"}
                    delay={200}
                  >
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
                      {service.name}
                    </h2>

                    <p className="text-gray-600 dark:text-gray-300 text-lg leading-relaxed whitespace-pre-line">
                      {window.innerWidth < 640
                        ? (service.description?.slice(0, 300) + (service.description?.length > 300 ? "..." : ""))
                        : (service.description?.slice(0, 557) + (service.description?.length > 557 ? "........." : ""))
                      }
                    </p>

                    <Link
                      to={`/servicesview/${service.id}`}
                      className="inline-flex items-center text-blue-600 dark:text-blue-400 font-semibold hover:underline group"
                    >
                      View Details
                      <ArrowRight className="ml-2 h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
                    </Link>
                  </RevealOnScroll>

                </div>
              ))
            ) : (
              <div className="text-center py-20">
                <p className="text-gray-500 dark:text-gray-400">No services found.</p>
              </div>
            )}
          </div>

        </div>
      </div>
    </PageTransition>
  );
};

export default Services;
